// @ts-nocheck

import { useState } from 'react'
import { connect } from 'react-redux'
import { Form, Input } from 'components/forms'
import { InfoButton } from 'components/buttons'
import { mergeRegistry } from 'registry/actions'
import { track, useTracking } from 'lib/analytics'
import { errorMessage } from 'lib/flash-message'
import PhotoUploader from '../components/photo-uploader'
import Slide from '../components/slide/slide'
import { createRegistry } from '../api'
import { getArrivalDate, getPlanningStage } from '../reducers'

import styles from './registry-create.scss'
import { useNavigate } from 'react-router-dom-v5-compat'

interface RegistryCreateProps {
  arrivalDate: string
  planningStage: string
  nextPath: string
  updateRegistry: func
}

function RegistryCreate({
  arrivalDate,
  planningStage,
  nextPath,
  updateRegistry,
}: RegistryCreateProps) {
  const tracker = useTracking()
  const [photoUrl, setPhotoUrl] = useState('')
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handlePhotoUpload = (url) => {
    setPhotoUrl(url)
  }

  const handleTitleChange = (event) => {
    setTitle(event.target.value)
  }

  const handleDescChange = (event) => {
    setDescription(event.target.value)
  }

  const handleOnSubmit = async () => {
    setLoading(true)

    const response = await handleCreateRegistry()

    tracker.trackEvent({
      event: track.listCreated,
      eventLocation: track.EventLocation.REGISTRY_CREATE_FORM,
      isRegistryOwner: true,
      // Responder currently only returns null or `birthday`.
      listType: response?.registry?.type || track.ListType.BABY_REGISTRY,
      registryId: response?.registry?.id,
      registryOwnerId: response?.registry?.ownerId,
    })

    navigate(nextPath)
    setLoading(false)
  }

  const handleCreateRegistry = async () => {
    let response
    setLoading(true)

    try {
      response = await createRegistry({
        registry: {
          title,
          description,
          family: {
            arrival_date: arrivalDate,
            planning_stage: planningStage,
          },
          photo_url: photoUrl,
        },
      })
      await updateRegistry(response)
      return response
    } catch (e) {
      errorMessage(e._error)
      console.error(e)
    } finally {
      setLoading(false)
    }

    return response
  }

  const hasTitle = !title.length

  return (
    <Slide title="Create Registry">
      <Form>
        <PhotoUploader
          className={styles.RegistryCreate__PhotoUploader}
          onChange={handlePhotoUpload}
          onEdit={handlePhotoUpload}
        />
        <Input
          id="title-field"
          label="Title*"
          name="title"
          placeholder="Your Baby Registry"
          type="text"
          onChange={handleTitleChange}
        />
        <Input
          id="greeting;-field"
          label="Registry Greeting"
          name="greeting"
          placeholder="Write a note to your friends and family"
          type="text"
          onChange={handleDescChange}
        />

        <InfoButton
          block
          pill
          aria-label="submit"
          className="mbl"
          disabled={hasTitle}
          submitting={loading}
          onClick={handleOnSubmit}
        >
          Continue
        </InfoButton>
      </Form>
    </Slide>
  )
}

const mapStateToProps = (state) => ({
  arrivalDate: getArrivalDate(state),
  planningStage: getPlanningStage(state),
})

const mapDispatchToProps = (dispatch) => ({
  updateRegistry: (registry) => {
    dispatch(mergeRegistry(registry))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(RegistryCreate)
